import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { FreudAlertMessagesModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AppointmentDetailsAlertComponent } from './appointment-details-alert.component';

@NgModule({
	declarations: [AppointmentDetailsAlertComponent],
	exports: [AppointmentDetailsAlertComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudTypographyModule,
		FreudAlertMessagesModule,
	],
})
export class AppointmentDetailsAlertModule {}
